"use client";

import {createClient} from "~/utils/supabase/client";
import Image from "next/image";

export function AppleSignin(
    { dictionary } : { dictionary: any }
) {

    const supabase = createClient();

    const loginWithApple = async () => {
        const { error } = await supabase.auth.signInWithOAuth({
            provider: "apple",
            options: {
                redirectTo: `${process.env.NEXT_PUBLIC_URL}/auth/callback`,
            }
        });
    }

    return (
        <button onClick={loginWithApple} type="submit" className="w-full inline-flex justify-center items-center gap-1 max-w-[342px] py-3 px-3 rounded-md outline-2 outline-offset-2 transition-colors bg-black hover:bg-black/80 active:bg-black/60 select-none">
            <div><Image src="/images/apple-logo.svg" height="22" width="22" alt="Apple" className="pr-2" /></div>
            <span className="font-jost font-semibold text-lg text-white">{dictionary.loginWithApple}</span>
        </button>
    )

}
